import { useEffect, useRef } from "react";

const RosseteHypotrochoid = () => {
  const svgRef = useRef(null);
  const settings = {
    N: 5.0,
    D: 4.0,
    d: 8.7,
    scale: 8, // Reduced to fit 350x350 SVG
    maxLineCount: 16,
    lineSpacing: 0.3,
    lineWidth: 1.0,
    speed: 0.006,
    bottomLeftColor: "#ff0000",
    centerColor: "#ff00ff",
    topRightColor: "#0000ff",
  };

  const ns = "http://www.w3.org/2000/svg";
  const width = 350;
  const height = 350;
  const centerX = 175; // Half of 350
  const centerY = 175;
  const updateInterval = 1000 / 30;

  useEffect(() => {
    const svg = svgRef.current;
    const defs = document.createElementNS(ns, "defs");
    const gradient = document.createElementNS(ns, "linearGradient");
    gradient.setAttribute("id", "hypotrochoidGradient");
    gradient.setAttribute("x1", "0%");
    gradient.setAttribute("y1", "100%");
    gradient.setAttribute("x2", "100%");
    gradient.setAttribute("y2", "0%");
    gradient.innerHTML = `
                    <stop offset="0%" stop-color="${settings.bottomLeftColor}" />
                    <stop offset="50%" stop-color="${settings.centerColor}" />
                    <stop offset="100%" stop-color="${settings.topRightColor}" />
                `;
    defs.appendChild(gradient);
    svg.appendChild(defs);

    const paths = [];
    let time = 0;
    let lastUpdate = 0;

    const createHypotrochoidPath = (R, r, d, scale, maxAngle, timeOffset) => {
      let pathData = "";
      const step = 0.05;
      for (let t = 0; t <= maxAngle; t += step) {
        const x =
          (R - r) * Math.cos(t + timeOffset) + d * Math.cos(((R - r) / r) * t);
        const y =
          (R - r) * Math.sin(t + timeOffset) - d * Math.sin(((R - r) / r) * t);
        const canvasX = centerX + x * scale;
        const canvasY = centerY + y * scale;
        pathData +=
          t === 0 ? `M ${canvasX},${canvasY} ` : `L ${canvasX},${canvasY} `;
      }
      pathData += "Z";
      return pathData;
    };

    const updatePaths = () => {
      while (svg.lastChild !== defs) svg.removeChild(svg.lastChild);
      paths.length = 0;

      const R = settings.N;
      const r = settings.D;
      const maxAngle = 2 * Math.PI * settings.D;

      for (let i = 0; i < settings.maxLineCount; i++) {
        const path = document.createElementNS(ns, "path");
        path.setAttribute(
          "d",
          createHypotrochoidPath(
            R,
            r,
            settings.d + i * settings.lineSpacing,
            settings.scale,
            maxAngle,
            i * 0.2
          )
        );
        path.setAttribute("stroke", "url(#hypotrochoidGradient)");
        path.setAttribute("stroke-width", settings.lineWidth);
        path.setAttribute("fill", "none");
        svg.appendChild(path);
        paths.push(path);
      }
    };
    updatePaths();

    const animate = (timestamp) => {
      time += settings.speed;

      if (timestamp - lastUpdate >= updateInterval) {
        const R = settings.N;
        const r = settings.D;
        const maxAngle = 2 * Math.PI * settings.D;

        for (let i = 0; i < settings.maxLineCount; i++) {
          paths[i].setAttribute(
            "d",
            createHypotrochoidPath(
              R,
              r,
              settings.d + i * settings.lineSpacing,
              settings.scale,
              maxAngle,
              i * 0.2 + time
            )
          );
        }
        lastUpdate = timestamp;
      }

      requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);
  }, []);

  return (
    <svg
      ref={svgRef}
      className="w-[350px] h-[350px]"
      width="350"
      height="350"
    ></svg>
  );
};

export default RosseteHypotrochoid;
